import { Header } from "@/components/Header";
import { Hero } from "@/components/Hero";
import { Marquee } from "@/components/Marquee";
import { About } from "@/components/About";
import { Therapies } from "@/components/Therapies";
import { Schedule } from "@/components/Schedule";
import { Gallery } from "@/components/Gallery";
import { Awards } from "@/components/Awards";
import { Testimonials } from "@/components/Testimonials";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

export default function Home() {
  return (
    <main data-testid="navyoga-home-page">
      <div className="grain-overlay" aria-hidden="true" />
      <Header />
      <Hero />
      <Marquee />
      <About />
      <Therapies />
      <Schedule />
      <Gallery />
      <Awards />
      <Testimonials />
      <Contact />
      <Footer />
    </main>
  );
}
